import img1 from "../images/creative-agenct.png";
import img2 from "../images/fb-clone.png";
import img3 from "../images/issue-solver.png";
import img4 from "../images/volunteer-network.png";
import img5 from "../images/messenger-clone.png";
const allprojectsdata = [
	{
		name: "Creative Agency",
		description:
      " A website for software firm to offer their services with both client & admin dashboard",
		img: img1,
		techused: "MERN Stack",
		livelink: "https://cloud-cafe-cc0b5.web.app/",
		githublink: "https://github.com/Fahimkhan9/creative-agency",
		id: 1,
	},
	{
		name: "Volunteer Network",
		description:
      "A website built with MERN stack for a non-profit organization. It helps volunteers to register for their volunteer activity",
		img: img4,
		techused: "MERN Stack",
		livelink: "https://loving-pasteur-1b842f.netlify.app/",
		githublink: "https://github.com/Fahimkhan9/volunteer-network-front-end",
		id: 2,
	},

	{
		name: "Issue Solver",
		description:
      "A website where people can ask their questions and get answers from people",
		img: img3,
		techused: "React.js  & Firebase",
		livelink: "https://issue-solver-6699b.web.app/",
		githublink: "https://github.com/Fahimkhan9/issue-solver",
		id: 3,
	},
	{
		name: "Fb Clone",
		description:
      " A single page and well-designed app where people are able to  add posts, give a like",
		img: img2,
		techused: "React.js & Firebase",
		livelink: "https://fb-clone-689cf.web.app/",
		githublink: "https://github.com/Fahimkhan9/fb-clone",
		id: 4,
	},
	{
		name: "Group Chat",
		description: " A single page web app where people can chat in a groups",
		img: img5,
		techused: "React.js & Firebase",
		livelink: "https://messenger-clone-20d62.web.app/",
		githublink: "https://github.com/Fahimkhan9/Messenger-Clone",
		id: 5,
	},
];

export default allprojectsdata;
